import {
	Combobox,
	ComboboxButton,
	ComboboxInput,
	ComboboxOption,
	ComboboxOptions,
} from '@headlessui/react';
import { ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import sortBy from 'lodash.sortby';
import { useState } from 'react';
import { Form } from 'react-router-dom';

const ZipCodeSearch = () => {
	const { data: taxonomies, isPending } = useQuery({
		queryKey: ['taxonomies'],
		queryFn: async () => {
			const { data } = await axios.get('/requests/cca-taxonomy-terms');
			return sortBy(data, ['taxonomy_name_reference']);
		},
	});
	const [selectedCounty, setSelectedCounty] = useState('');
	const [selectedZipCode, setSelectedZipCode] = useState('');
	const [selectedTaxonomy, setSelectedTaxonomy] = useState('');
	const [taxonomyFilter, setTaxonomyFilter] = useState('');

	let filteredTaxonomies = [];
	if (!isPending) {
		filteredTaxonomies =
			taxonomies && taxonomyFilter === ''
				? taxonomies
				: taxonomies.filter((taxonomy) =>
						taxonomy.taxonomy_name_reference
							.toLowerCase()
							.replace(/\s+/g, '')
							.includes(taxonomyFilter.toLowerCase().replace(/\s+/g, '')),
					);
	}

	return (
		<div className="page zip-code-search">
			<div className="text-center sm:mx-auto sm:w-full sm:max-w-lg">
				<h2>Get Assistance and the Help you need!</h2>
			</div>
			<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-sm">
				<p>
					Needing assistance with food, transportation, medical bills and
					housing? We can help! Use the search below to start finding available
					services in your area!
				</p>
			</div>
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<Form action="/organizations" className="space-y-6" method="get">
					<div className="mt-6 form-control">
						<label htmlFor="county" className="label label-text">
							County
						</label>
						<select
							id="county"
							name="county"
							className="w-full input select-sm select-bordered"
							required
							onChange={({ target }) => setSelectedCounty(target.value)}
							value={selectedCounty}
						>
							<option value="">-- Select a County --</option>
							<option value="muskegon">Muskegon</option>
						</select>
					</div>
					<div className="mt-6 form-control">
						<label htmlFor="zip-code" className="label label-text">
							Zip Code
						</label>
						<input
							type="text"
							inputMode="numeric"
							required
							id="zip-code"
							name="zipCode"
							className="w-full input input-sm input-bordered"
							onChange={({ target }) => setSelectedZipCode(target.value)}
							value={selectedZipCode}
							disabled={isEmpty(selectedCounty)}
						/>
					</div>
					<div className="mt-6 form-control">
						<label className="label label-text">Program</label>
						<Combobox
							as="div"
							className="relative"
							value={selectedTaxonomy}
							onChange={setSelectedTaxonomy}
							name="taxonomy"
						>
							<ComboboxInput
								className="w-full input input-sm input-bordered"
								required
								displayValue={(taxonomy) => taxonomy?.taxonomy_name_reference}
								onChange={(event) => setTaxonomyFilter(event.target.value)}
								autoComplete="off"
								placeholder="food, rent assistance, diapers, etc."
							/>
							<ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
								<ChevronUpDownIcon
									className="w-5 h-5 text-gray-400"
									aria-hidden="true"
								/>
							</ComboboxButton>
							<ComboboxOptions className="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
								{filteredTaxonomies.map((taxonomy) => (
									<ComboboxOption
										key={taxonomy.taxonomy_code}
										value={taxonomy}
										className="relative px-2 py-1 cursor-default select-none data-focus:bg-tandem-100"
									>
										{taxonomy.taxonomy_name_reference}
									</ComboboxOption>
								))}
							</ComboboxOptions>
						</Combobox>
					</div>
					<div className="mt-6">
						<button
							className="text-white btn btn-primary btn-sm btn-block"
							disabled={
								isPending ||
								isEmpty(selectedTaxonomy) ||
								isEmpty(selectedZipCode) ||
								isEmpty(selectedCounty)
							}
						>
							Search
						</button>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default ZipCodeSearch;
